export default __webpack_public_path__ + "static/media/Anemia.051e7699.svg";